// extracted by mini-css-extract-plugin
export default {"blogs__wrapper":"blogs_blogs__wrapper__4eICu","blogs__grid_wrapper":"blogs_blogs__grid_wrapper__yAGjz","heading":"blogs_heading__-5OuC","subhead":"blogs_subhead__G9jed"};